import React, { useState, useEffect } from 'react';
import TR from './../../Trans';
import PropTypes from 'prop-types';
import 'video.js/dist/video-js.css';
import LinearProgressWithLabel from '../items/LinearProgressWithLabel';
import Popover from '@mui/material/Popover';
import IntervalService from './../../services/intervals';
import { Views } from './../../enums/enums';
import { ReactComponent as MutedIcon } from './../../assets/muted.svg';
import ContentContainer from './../items/ContentContainer';
import FormControlLabel from '@mui/material/FormControlLabel';
import Select from '@mui/material/Select';
import { getOS, getPlatform, isIPhone, isPossiblyIPad } from '../../services/os';
import { Capacitor } from '@capacitor/core';
import SvgIcon from '@mui/material/SvgIcon';
import BackgroundMusicBottomBar from '../items/BackgroundMusicBottomBar';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import Checkbox from '@mui/material/Checkbox';
import Stack from '@mui/material/Stack';
import Grid from '@mui/material/Grid';
import { ReactComponent as PlayIcon } from './../../assets/play.svg';
import { ReactComponent as PauseIcon } from './../../assets/pause.svg';
import { ReactComponent as NextIcon } from './../../assets/next.svg';
import { ReactComponent as PrevIcon } from './../../assets/prev.svg';
import BackgroundMusicList from '../player/BackgroundMusicList';
import BackgroundHistoryList from '../player/BackgroundHistoryList';
import Button from '@mui/material/Button';
import Box from '@mui/material/Box';
import IconButton from '@mui/material/IconButton';
import Tooltip from '@mui/material/Tooltip';
import MenuItem from '@mui/material/MenuItem';
import Menu from '@mui/material/Menu';
import Waiting from './../items/Waiting';
import { ReactComponent as VolumeIcon } from './../../assets/volume.svg';
import sessionStore from './../../stores/session';
import environmentStore from './../../stores/environment';
import musicPlayerStore from '../../stores/musicPlayer';
import bgPerformanceStore from '../../stores/bgPerformance';
import playerStore from '../../stores/player';
import settingsStore from '../../stores/settings';
import navigationStore from '../../stores/navigation';
import accountStore from '../../stores/account';
import singersStore from '../../stores/singers';
import bgFiltersStore from '../../stores/bgFilters';
import BgPlayerLinearProgressWithLabel from '../items/BgPlayerLinearProgressWithLabel';
import messageStore from '../../stores/message';

function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`music-tabpanel-${index}`}
      aria-labelledby={`music-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box sx={{ p: 0 }}>
          {children}
        </Box>
      )}
    </div>
  );
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired,
};

function tabProps(index) {
  return {
    id: `music-tab-${index}`,
    'aria-controls': `music-tabpanel-${index}`,
  };
}

function BgPlayer() {

  const [tabValue, setTabValue] = useState(0);

  const itemsOnPage = 25;
  const isWaiting = musicPlayerStore((state) => state.isWaiting);
  const goToView = navigationStore((state) => state.goToView);
  const isGettingMusic = bgPerformanceStore((state) => state.isWaiting);
  const getSettings = settingsStore((state) => state.getSettings);
  const sessionToken = sessionStore((state) => state.sessionToken);
  const getEnvironment = environmentStore((state) => state.getEnvironment);
  const environment = environmentStore((state) => state.environment);
  const streamUrl = musicPlayerStore((state) => state.streamUrl);
  const isPlayerStopped = playerStore((state) => state.isStopped);
  const isPlayerPlaying = playerStore((state) => state.isPlaying);
  const history = bgPerformanceStore((state) => state.history);
  const currentTrack = musicPlayerStore((state) => state.currentTrack);
  const setFadeVolume = musicPlayerStore((state) => state.setFadeVolume);
  const singers = singersStore((state) => state.singers);
  const getSingers = singersStore((state) => state.getSingers);
  //const toNext = musicStore((state) => state.toNext);
  const isPlaying = musicPlayerStore((state) => state.isPlaying);
  const setIsPaused = musicPlayerStore((state) => state.setIsPaused);
  const setFrom = musicPlayerStore((state) => state.setFrom);
  //const currentTime = musicPlayerStore((state) => state.currentTime);
  const getStreamUrl = musicPlayerStore((state) => state.getStreamUrl);
  //const settings = settingsStore((state) => state.settings);
  const settingsMusicPlayListId = settingsStore((state) => state.settings?.music_playlist_id);
  const settingsMusicEnabled = settingsStore((state) => state.settings?.music_enabled);
  const settingsMusicStyleId = settingsStore((state) => state.settings?.music_style_id)
  const setSettings = settingsStore((state) => state.setSettings);
  const currentVolume = musicPlayerStore((state) => state.currentVolume);
  const setVolume = musicPlayerStore((state) => state.setVolume);
  const isMusicOn = musicPlayerStore((state) => state.isMusicOn);
  const setIsMusicOn = musicPlayerStore((state) => state.setIsMusicOn);
  const isPaused = musicPlayerStore((state) => state.isPaused);
  const isSaveable = musicPlayerStore((state) => state.isSaveable);
  const isWaitingInitial = musicPlayerStore((state) => state.isWaitingInitial);
  const isInGenres = musicPlayerStore((state) => state.isInGenres);
  const setPaddingBottom = navigationStore((state) => state.setPaddingBottom);
  const playQueue = bgPerformanceStore((state) => state.playQueue);
  const getPlayQueue = bgPerformanceStore((state) => state.getPlayQueue);
  const getHistory = bgPerformanceStore((state) => state.getHistory);
  const currentPerformance = bgPerformanceStore((state) => state.currentPerformance);
  const deletePerformance = bgPerformanceStore((state) => state.deletePerformance);
  const playerFilter = bgFiltersStore((state) => state.playerFilter);
  const addPerformanceToHistory = bgPerformanceStore((state) => state.addPerformanceToHistory);
  const getMoreTracks = bgPerformanceStore((state) => state.getMoreTracks);
  const filters = bgFiltersStore((state) => state.filters);
  const setCurrentFilter = bgFiltersStore((state) => state.setCurrentFilter);
  const getFilters = bgFiltersStore((state) => state.getFilters);
  const prevFromHistory = bgPerformanceStore((state) => state.prevFromHistory);
  const setPlayerFilter = bgFiltersStore((state) => state.setPlayerFilter);
  const repeatPlayList = bgPerformanceStore((state) => state.repeatPlayList);
  const addPlayListToTheEnd = bgPerformanceStore((state) => state.addPlayListToTheEnd);
  const setRepeatPlayListFromId = bgPerformanceStore((state) => state.setRepeatPlayListFromId);
  const playLists = bgPerformanceStore((state) => state.playLists);
  const getPlayLists = bgPerformanceStore((state) => state.getPlayLists);
  const filterOutPlayQueue = bgPerformanceStore((state) => state.filterOutPlayQueue);
  const emptyPlayerFilter = bgFiltersStore((state) => state.emptyPlayerFilter);
  const safeArea = navigationStore((state) => state.safeArea);
  const clearAllAutoAdded = bgPerformanceStore((state) => state.clearAllAutoAdded);
  const emptyPlayer = musicPlayerStore((state) => state.empty);
  const setRepeatPlayList = bgPerformanceStore((state) => state.setRepeatPlayList);
  const setIsWaitingForNextPrev = musicPlayerStore((state) => state.setIsWaitingForNextPrev);
  const isWaitingForNextPrev = musicPlayerStore((state) => state.isWaitingForNextPrev);
  const account = accountStore((state) => state.account);
  const getAccount = accountStore((state) => state.getAccount);
  const setMessage = messageStore((state) => state.setMessage);
  const isBgPlayerInit = navigationStore((state) => state.isBgPlayerInit);
  const setBgPlayerInit = navigationStore((state) => state.setBgPlayerInit);

  const [anchorElLoad, setAnchorElLoad] = useState(null);
  const [isBackgroundMusicFilterLoadMenuOpen, setBackgroundMusicFilterLoadMenuOpen] = useState(false);

  const [anchorAudioEl, setAnchorAudioEl] = React.useState(null);
  const [, updateState] = useState();
  const openAudioPopover = Boolean(anchorAudioEl);

  const handleBackgroundMusicFilterLoadMenuClose = () => {
    setBackgroundMusicFilterLoadMenuOpen(false);
  };

  const handleOpenBackgroundMusicFilterLoadMenu = (event) => {
    setAnchorElLoad(event.currentTarget);
    setBackgroundMusicFilterLoadMenuOpen(true);
  };

  useEffect(() => {
    if (!environment) {
      getEnvironment(sessionToken);
    }
    if (!singers) {
      getSingers(sessionToken);
    }
    if (!filters) {
      getFilters(sessionToken);
    }
    if (!playQueue) {
      getPlayQueue(sessionToken);
    }
    if (!history) {
      getHistory(sessionToken);
    }
    if (!filters) {
      getFilters(sessionToken);
    }
    if (!playLists) {
      getPlayLists(sessionToken);
    }
    setPaddingBottom("muvika-music-list", -50);
  }, []);

  useEffect(() => {
    if (settingsMusicPlayListId && playLists) {
      setRepeatPlayListFromId(settingsMusicPlayListId);
    }
  }, [settingsMusicPlayListId]);

  useEffect(() => {
    if (playLists && settingsMusicPlayListId) {
      setRepeatPlayListFromId(settingsMusicPlayListId);
    }
  }, [playLists]);

  const getMoreMusicTracks = () => {
    if (playQueue && singers) {
      if (!isGettingMusic) {
        setPaddingBottom("muvika-music-list", -50);
        if (playQueue.items.length == 0) {
          emptyPlayer();
        }
        if (repeatPlayList) {
          if ((!currentPerformance || playQueue.items.length < 4)) {
            addPlayListToTheEnd(sessionToken, repeatPlayList);
          }
        } else {
          if ((!currentPerformance || playQueue.items.length < 4) && bgFiltersStore.getState().playerFilter) {
            getMoreTracks(sessionToken, 5, singers[0], bgFiltersStore.getState().playerFilter);
          }
        }
      }
    } else {
      emptyPlayer();
    }
  };

  useEffect(() => {
    console.log("playerFilter", "playQueue");
    getMoreMusicTracks();
  }, [playQueue]);

  useEffect(() => {
    console.log("playerFilter", "currentPerformance");
    getMoreMusicTracks();
  }, [currentPerformance]);

  useEffect(() => {
    console.log("playerFilter", "playerFilter");
    getMoreMusicTracks();
  }, [playerFilter]);

  useEffect(() => {
    console.log("playerFilter", "playerFilter");
    if (playerFilter && isBgPlayerInit) {
      setMessage(sessionToken, TR.cm_style_applied);
    }
  }, [settingsMusicStyleId]);

  useEffect(() => {
    if (settingsMusicEnabled) {
      setIsMusicOn(settingsMusicEnabled == 1);
      if (filters) {
        console.log("filterId")
        setCurrentFilterFromSettings();
      }
    }
  }, [settingsMusicEnabled]);

  useEffect(() => {
    if (filters && settingsMusicStyleId) {
      console.log("filterId")
      setCurrentFilterFromSettings();
    }
  }, [filters]);

  const setCurrentFilterFromSettings = () => {
    let musicFilterId = settingsMusicStyleId;
    if (musicFilterId) {
      console.log("filterId", musicFilterId)
      setPlayerFilter(musicFilterId);
    }
  };

  const lengthToMinutes = (length) => {
    const splitted = length.split(":");
    if (splitted.length == 3) {
      return splitted[1] + ":" + splitted[2];
    }
  };

  const getLength = (track) => {
    if (track) {
      return lengthToMinutes(track.length);
    }
    return "";
  };

  const toMMSS = (secs) => {
    var sec_num = parseInt(secs, 10);
    var hours = Math.floor(sec_num / 3600);
    var minutes = Math.floor(sec_num / 60) % 60;
    var seconds = sec_num % 60;

    return [hours, minutes, seconds]
      .map(v => v < 10 ? "0" + v : v)
      .filter((v, i) => v !== "00" || i > 0)
      .join(":");
  };

  const play = () => {
    if (!IntervalService.isFadingOut() && !IntervalService.isFadingIn()) {
      if (account && singers) {
        if (account.subscription.valid == 1) {
          window.dispatchEvent(new Event('muvika-background-music-play-clicked'));
          if (!isPlayerStopped.isStopped) {
            setIsPaused(false);
          } else {
            if (isMusicOn) {
              setIsPaused(false);
              if (streamUrl.length == 0) {
                console.log("stream_url_get");
                getStreamUrl(sessionToken, currentPerformance, currentPerformance.track, singers[0], true);
              }
            }
          }
        }
      }
    }
  };

  const pause = () => {
    if (!IntervalService.isFadingOut() && !IntervalService.isFadingIn()) {
      window.dispatchEvent(new Event('muvika-background-music-pause-clicked'));
      setIsPaused(true);
    }
  };

  const handleMusicOn = () => {
    if (account) {
      if (account.subscription.valid == 1) {
        setIsPaused(isMusicOn);
      }
    }
    if (settingsStore.getState().settings) {
      let newSettings = { ...settingsStore.getState().settings };
      newSettings.music_enabled = !isMusicOn;
      setSettings(sessionToken, newSettings, false);
    }
    setIsMusicOn(!isMusicOn);
  };

  const saveRepeatPlayList = (playListId) => {
    let newSettings = { ...settingsStore.getState().settings };
    newSettings.music_playlist_id = playListId;
    setSettings(sessionToken, newSettings, false);
  };

  const handleStopRepeat = () => {
    setRepeatPlayList(null);
    saveRepeatPlayList(0);
  };

  const handleClickAudio = (event) => {
    setAnchorAudioEl(event.currentTarget);
  };

  const handleCloseAudio = () => {
    setAnchorAudioEl(null);
  };

  const handleSave = () => {
    if (currentTrack) {
      if (isInGenres(currentTrack)) {
        //getTracks(sessionToken, itemsOnPage, singers[0]);
      } else {
        fader(() => {
          //getTracks(sessionToken, itemsOnPage, singers[0]);
        });
      }
    } else {
      //getTracks(sessionToken, itemsOnPage, singers[0]);
    }
  };

  const handleVolumeClick = (event) => {
    let rect = event.currentTarget.getBoundingClientRect();
    const x = (event.clientX - rect.left) / event.currentTarget.offsetWidth;
    setVolume(x);
    if (settingsStore.getState().settings) {
      let newSettings = { ...settingsStore.getState().settings };
      newSettings.music_volume = Math.round(x * 100);
      setSettings(sessionToken, newSettings, false);
    }
  };

  const handleProgressClick = (event) => {
    let rect = event.currentTarget.getBoundingClientRect();
    const x = ((event.clientX - rect.left) * currentTrack.length.split(':').reduce((acc, time) => (60 * acc) + +time)) / event.currentTarget.offsetWidth;
    setFrom(x);
  };

  const currentProgress = () => {
    if (currentTrack && currentTrack.length) {
      return (musicPlayerStore.getState().currentTime / currentTrack.length.split(':').reduce((acc, time) => (60 * acc) + +time)) * 100;
    } else {
      return 0;
    }
  };

  const fader = (callback) => {
    let times = 10;
    let volume = currentVolume.currentVolume;
    let reduceBy = volume / times;
    let interval = setInterval(function () {
      if (times > 0) {
        volume = volume - reduceBy;
        setFadeVolume(volume);
        times = times - 1;
      } else {
        clearInterval(interval);
        callback();
      }
    }, 100);
  };

  const prev = () => {
    if (!IntervalService.isFadingOut() && !IntervalService.isFadingIn()) {
      if (musicPlayerStore.getState().currentTime > 5) {
        setFrom(0);
      } else {
        if (history.items.length > 0) {
          window.dispatchEvent(new Event('muvika-background-music-prev-clicked'));
          setIsWaitingForNextPrev(true);
          prevFromHistory(sessionToken);
        }
      }
    }
  };

  const next = () => {
    if (currentPerformance && (!IntervalService.isFadingOut() && !IntervalService.isFadingIn())) {
      window.dispatchEvent(new Event('muvika-background-music-next-clicked'));
      setIsWaitingForNextPrev(true);
      addPerformanceToHistory(sessionToken, currentPerformance);
      deletePerformance(sessionToken, currentPerformance.unique_id);
    }
  };

  const renderWaiting = () => {
    if (isWaiting) {
      return <Waiting />;
    }
  };

  const renderSaveButton = () => {
    if (isSaveable) {
      return <div className="muvika-save-div">
        <Button className="muvika-save-button" variant="text" color="success" onClick={
          handleSave
        }>{TR.cm_save}
        </Button>
      </div>;
    }
  };

  const renderProgressLine = () => {
    if (currentPerformance) {
      return <BgPlayerLinearProgressWithLabel onProgressClick={handleProgressClick} />;
      //return <LinearProgressWithLabel currentTime={toMMSS(musicPlayerStore.getState().currentTime)} buffer={currentBuffer * 100} value={currentProgress()} length={getLength(currentPerformance.track)} onProgressClick={handleProgressClick} />;
    }
  };

  const renderPlayPause = () => {
    if (isPaused.isPaused) {
      return <Tooltip title={TR.cm_play}>
        <IconButton color="white" component="label" size="small" onClick={play}>
          <SvgIcon className="muvika-icon" component={PlayIcon} />
        </IconButton>
      </Tooltip>;
    } else {
      return <Tooltip title={TR.cm_pause}>
        <IconButton color="white" component="label" size="small" onClick={pause}>
          <SvgIcon className="muvika-icon" component={PauseIcon} />
        </IconButton>
      </Tooltip>;
    }
  };

  const renderPrevButton = () => {
    return <Tooltip title={TR.cm_previous}>
      <IconButton disabled={isWaitingForNextPrev} className="muvika-player-button" color="white" component="label" size="small" onClick={() => prev()}>
        <SvgIcon className="muvika-icon" component={PrevIcon} />
      </IconButton>
    </Tooltip>;
  };

  const renderNextButton = () => {
    return <Tooltip title={TR.cm_next}>
      <IconButton disabled={isWaitingForNextPrev} className="muvika-player-button" color="white" component="label" size="small" onClick={() => next()}>
        <SvgIcon className="muvika-icon" component={NextIcon} />
      </IconButton>
    </Tooltip>;
  };

  const renderWaitingForKaraoke = () => {
    if (!isPaused.isPaused && !isPlayerStopped.isStopped) {
      return <div style={{ position: "relative" }}>
        <span className="muvika-background-music-waiting">
          {TR.cm_waiting_for_karaoke_to_finish}
        </span>
      </div>;
    }
  };

  const renderVolIcon = () => {
    if (currentVolume.currentVolume > 0) {
      return <SvgIcon className="muvika-icon" component={VolumeIcon} />;
    } else {
      return <SvgIcon className="muvika-icon" component={MutedIcon} />;
    }
  };

  const renderVolumeButton = () => {
    if ((!isIPhone() && !isPossiblyIPad()) || Capacitor.isNativePlatform()) {
      return <Tooltip title={TR.cm_volume}>
        <IconButton color="white" component="label" size="small" onClick={handleClickAudio}>
          {renderVolIcon()}
        </IconButton>
      </Tooltip>;
    }
  };

  const renderPlayer = () => {
    if (isMusicOn && currentPerformance) {
      return <div className="muvika-background-music-player">
        <Stack direction={"row"} spacing={1}>
          <div className="muvika-background-music-player-left">
            <Stack direction={"row"} spacing={1}>
              {renderPrevButton()}
              {renderPlayPause()}
              {renderNextButton()}
              {renderVolumeButton()}
            </Stack>
          </div>
          <div className="muvika-background-music-player-right">
            {renderProgressLine()}
            {renderWaitingForKaraoke()}
          </div>
        </Stack>
      </div>;
    }
  };

  const handlePlayerFilterChange = (event) => {
    let filterId = event.target.value;
    if (filterId === 0) {
      emptyPlayerFilter();
      let newSettings = { ...settingsStore.getState().settings };
      newSettings.music_style_id = 0;
      setSettings(sessionToken, newSettings, false);
      clearAllAutoAdded(sessionToken);
    } else if (filterId == -1) {
      goToView(Views.BackgroundMusicStyles);
    } else {
      setBgPlayerInit(true);
      setPlayerFilter(filterId);
      let newSettings = { ...settingsStore.getState().settings };
      newSettings.music_style_id = filterId;
      console.log(newSettings);
      setSettings(sessionToken, newSettings, false);
      filterOutPlayQueue(sessionToken, bgFiltersStore.getState().playerFilter);
    }
  };

  const filterListOpenStyles = () => {
    if (filters) {
      if (filters.length == 0) {
        return <MenuItem value={-1}>{TR.cm_open_styles}...</MenuItem>;
      }
    }
  };

  const renderFilter = () => {
    if (!repeatPlayList) {
      let filter = playerFilter;
      return <Stack direction="row" spacing={2} justifyContent="right">
        <span className="muvika-filter-name-player">{TR.cm_bg_auto_from_style}: </span>
        <Select disabled={isGettingMusic} className="muvika-music-select"
          value={filter ? filter.id : 0}
          onChange={handlePlayerFilterChange}
        >
          <MenuItem value={0}>{TR.ss_disabled}</MenuItem>
          {filterListOpenStyles()}
          {renderFiltersLoadList()}
        </Select>
      </Stack>;
    }
  };

  const renderFiltersLoadList = () => {
    if (filters) {
      return filters.map((filter, index) =>
        <MenuItem key={filter.id} value={filter.id}>
          {filter.name}
        </MenuItem>
      );
    }
  };

  const renderPlayListInfo = () => {
    if (repeatPlayList) {
      return <span>{TR.cm_bg_currently_playlists} <b>{repeatPlayList.name}</b> <Button color="secondary" onClick={handleStopRepeat}>{TR.cm_stop_repeat}</Button></span>;
    }
  };

  const renderContainer = () => {
    console.log("renderPlayer", isMusicOn);
    if (account) {
      if (!(account.subscription.valid == 0)) {
        if (isMusicOn) {
          return <div>
            {renderPlayer()}
            {renderFilter()}
            {renderPlayListInfo()}
            <Menu disableAutoFocus disableEnforceFocus disableRestoreFocus
              id={"menu-music-filter-load"}
              style={{ zIndex: 99999 }}
              open={isBackgroundMusicFilterLoadMenuOpen}
              anchorEl={anchorElLoad}
              onClose={handleBackgroundMusicFilterLoadMenuClose}
              MenuListProps={{
                'aria-labelledby': "menu-music-filter-load",
              }}
            >
              {renderFiltersLoadList()}
            </Menu>
            <Popover
              open={openAudioPopover}
              anchorEl={anchorAudioEl}
              onClose={handleCloseAudio}
              anchorOrigin={{
                vertical: 'bottom',
                horizontal: 'left',
              }}

            >
              <div className="muvika-background-music-audio-progress">
                <LinearProgressWithLabel currentTime={Math.round(currentVolume.currentVolume * 100) + "%"} buffer={0} value={currentVolume.currentVolume * 100} length={""} onProgressClick={handleVolumeClick} />
              </div>
            </Popover>
            <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
              <Tabs
                value={tabValue}
                onChange={changeTab}
                TabIndicatorProps={{
                  style: {
                    backgroundColor: "var(--selected-color)",
                    fontWeight: "var(--selected-font-weight) !important"
                  }
                }}>
                <Tab sx={{ color: "var(--text-color)", textTransform: "none", fontSize: "1rem" }} label={renderPlayQueueLabel()} {...tabProps(0)} />
                <Tab sx={{ color: "var(--text-color)", textTransform: "none", fontSize: "1rem" }} label={TR.cm_history} {...tabProps(1)} />
              </Tabs>
            </Box>
            <ContentContainer id={tabValue == 0 ? "muvika-music-list" : "muvika-music-history-list"} onScrollDown={() => {
            }} isFinished={true}>
              <TabPanel value={tabValue} index={0} className="muvika-music-list-tab">
                {musicList()}
              </TabPanel>
              <TabPanel value={tabValue} index={1} className="muvika-music-history-tab">
                {musicHistory()}
              </TabPanel>
            </ContentContainer>
          </div>;
        }
      }
    }
  };

  const renderMusicCheckBox = () => {
    if (isWaitingInitial) {
      return <Waiting />;
    } else {
      return <FormControlLabel onChange={handleMusicOn} control={<Checkbox checked={isMusicOn} />} label={TR.cm_enable_background_music} />;
    }
  };

  const changeTab = (event, val) => {
    if (val == 0) {
      setPaddingBottom("muvika-music-list", -50);
    } else if (val == 1) {
      setPaddingBottom("muvika-music-list", 14);
    }
    setTabValue(val);
  };

  const renderPlayQueueLabel = () => {
    return <span>{TR.cm_playqueue}</span>;
  };

  const musicList = () => {
    if (playQueue) {
      return <BackgroundMusicList />;
    }
  };

  const musicHistory = () => {
    if (history) {
      return <BackgroundHistoryList />;
    }
  };

  const renderBottomBar = () => {
    if (account) {
      if (!(account.subscription.valid == 0)) {
        return <BackgroundMusicBottomBar />;
      }
    }
  }

  return (
    <div>
      <h3>{TR.cm_background_music}</h3>
      {renderMusicCheckBox()}
      {renderContainer()}
      <Box mt={1} bottom="0" className="muvika-music-player-bottom"
        sx={{
          paddingLeft: safeArea ? safeArea.left + "px" : "0.2rem !important",
          paddingRight: safeArea ? safeArea.right + "px" : "0.2rem !important"
        }}
      >
        {renderBottomBar()}
      </Box>
    </div>
  );
};

export default BgPlayer;